import { useCallback, useEffect } from 'react'

import { useAtom } from 'jotai'

import { createBlankSubItem, SubItem, subItemsAtom } from '../../state.atoms'
import { isSubItemCompleted } from './helpers'

export const useSubItems = () => {
  const [subItems, setSubItems] = useAtom(subItemsAtom)

  const lastSubItem = subItems.at(-1)

  /**
   * Add a new blank subitem when the last subitem is filled out
   */
  useEffect(() => {
    if (lastSubItem && isSubItemCompleted(lastSubItem)) {
      setSubItems([...subItems, createBlankSubItem()])
    }
  }, [subItems, lastSubItem, setSubItems])

  const addSubItem = useCallback(() => {
    setSubItems([...subItems, createBlankSubItem()])
  }, [subItems, setSubItems])

  const updateSubItem = useCallback(
    (updatedSubItem: SubItem) => {
      setSubItems(
        subItems.map(subItem => {
          if (subItem.id === updatedSubItem.id) {
            return updatedSubItem
          }

          return subItem
        })
      )
    },
    [subItems, setSubItems]
  )

  const removeSubItem = useCallback(
    (subItemId: string) => {
      const lastSubItem = subItems.at(-1)
      const isLastSubItem = subItemId === lastSubItem?.id

      setSubItems([
        ...subItems.filter(subItem => subItem.id !== subItemId),
        ...(isLastSubItem ? [createBlankSubItem()] : [])
      ])
    },
    [setSubItems, subItems]
  )

  return { addSubItem, updateSubItem, removeSubItem }
}
